export const CREATE_PRODUCT_ACCESSORY = 'CREATE_PRODUCT_ACCESSORY'
export const GET_LIST_PRODUCT_ACCESSORY = 'GET_LIST_PRODUCT_ACCESSORY'
export const DETAIL_PRODUCT_ACCESSORY = 'DETAIL_PRODUCT_ACCESSORY'
export const PATCH_PRODUCT_ACCESSORY = 'PATCH_PRODUCT_ACCESSORY'
